// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"934ff760","237":"7b835731","363":"282eec1f","483":"d39981f9","518":"9d052fcf","533":"43222afb","535":"5eabaeb6","584":"82da450b","738":"1baf1774","752":"fe25c47e","885":"5a5fb9aa"}[chunkId] + ".chunk.js";
};